module.exports = __webpack_public_path__ + "static/media/weight-hanging.b48b3aab.svg";